// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { cognitoAuthConfig } from "./config/authConfig";

// Update redirect_uri to match your deployment environment

// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_mKClWJ8CK",
//   client_id: "4e9b8um7epfsqn04set3aj862m",
//   redirect_uri: "http://localhost:3000/dashboard",
//   response_type: "code",
//   scope: "email openid phone",
// };

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);